/**
 * AIアシスタントのサンプル質問
 *
 * @注意 質問選択時にGAにidを送信して質問内容ごとに利用状況を管理しています。
 * 新規に質問を追加する場合はidを繰り上げてください。
 * PO共有用ドキュメント：https://www.notion.so/AI-1d9a4e41249f801393a8ee481ca28c8b
 */
export const aiAssistantSampleQuestions: {
  id: number; // 質問のIDに使用する。新規に質問を追加する場合はidを繰り上げてください。
  order: number; // 質問の表示順
  value: string;
  isView: boolean; // 画面で表示するかどうかのフラグ
}[] = [
  { id: 1, order: 20, value: 'アウト支持率とはどんなデータ？', isView: true },
  { id: 2, order: 30, value: 'SP玉粗利´ってなんですか', isView: true },
  {
    id: 3,
    order: 40,
    value: 'PPMシェアはどのように活用すればいい？',
    isView: true,
  },
  { id: 4, order: 40, value: 'アカウントの追加・編集がしたい', isView: false },
  {
    id: 5,
    order: 10,
    value: 'ユーザー毎にログイン許可するIPを指定したい',
    isView: true,
  },
];
